'use client';


import { Button } from '@nextui-org/react';

import {
  useAddMasterclassesToLocalStorageFavoritesMutation,
  useAddMasterclassToFavoritesMutation,
  useRemoveMasterclassesFromLocalStorageFavoritesMutation,
  useRemoveMasterclassFromFavoritesMutation,
} from '@/entities/favorite/query';
import { checkInFavoritesLocalStorage } from '@/entities/favorite/utils';
import { IMasterclass } from '@/entities/masterclass/types';
import { useIsAuthorizated } from '@/shared/hooks/is-authorizated';
import './mc-like-btn.css';

export const McLikeBtn = ({
  mc,
  strokeWidth,
  stroke,
  size = 28,
  withBg = false,
  custom = false,
}: {
  mc?: IMasterclass;
  strokeWidth?: number;
  stroke?: string;
  size?: number;
  withBg?: boolean;
  custom?: boolean;
}) => {
  const { mutate: add, isPending: isPendingAdd } =
    useAddMasterclassToFavoritesMutation();
  const { mutate: addItemLocalStorage } =
    useAddMasterclassesToLocalStorageFavoritesMutation();
  const { mutate: removeItemLocalStorage } =
    useRemoveMasterclassesFromLocalStorageFavoritesMutation();
  const { mutate: remove, isPending: isPendingRemove } =
    useRemoveMasterclassFromFavoritesMutation();
  const { isAuthorizated } = useIsAuthorizated();

  const liked = (mc?.isLiked || checkInFavoritesLocalStorage(mc?.id)) ?? false;

  if (!mc) {
    return null;
  }
  const onClickHandler = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    if (isPendingAdd || isPendingRemove) {
      return;
    }
    // if (!isAuthorizated) {
    //   return message.info(
    //     'Чтобы добавить товар в избранное, требуется авторизация',
    //   );
    // }
    // setLiked((prev) => !prev);
    if (liked) {
      isAuthorizated ? remove(mc.id) : removeItemLocalStorage(mc.id);
    } else {
      isAuthorizated ? add(mc.id) : addItemLocalStorage(mc.id);
    }
  };

  const svg = (
    <svg
      strokeWidth={strokeWidth ?? 0.5}
      key={mc.id}
      stroke={liked ? '#FF0000' : stroke ? stroke : '#858585FF'}
      fill={liked ? '#FF0000' : '#FFFFFF'}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      aria-hidden="true"
      role="img"
      // eslint-disable-next-line
      className="text-default-900/50 iconify iconify--solar"
      width={size}
      onClick={onClickHandler}
      height={size}
      viewBox="0 0 24 24"
    >
      <path
        fill={liked ? '#FF0000' : withBg ? 'currentColor' : 'transparent'}
        d="M2 9.137C2 14 6.02 16.591 8.962 18.911C10 19.729 11 20.5 12 20.5s2-.77 3.038-1.59C17.981 16.592 22 14 22 9.138S16.5.825 12 5.501C7.5.825 2 4.274 2 9.137"
      ></path>
    </svg>
  );

  const likeLabel = liked ? 'Убрать из избранного' : 'Добавить в избранное';

  if (custom) {
    return (
      <Button
        onClick={onClickHandler}
        size="lg"
        radius="full"
        isIconOnly
        aria-label={likeLabel}
      >
        {svg}
      </Button>
    );
  }
  return (
    <>
      {withBg ? (
        <Button
          onClick={onClickHandler}
          aria-label={likeLabel}
          className="group inline-flex items-center justify-center box-border appearance-none select-none whitespace-nowrap font-normal subpixel-antialiased overflow-hidden tap-highlight-transparent data-[pressed=true]:scale-[0.97] outline-none data-[focus-visible=true]:z-10 data-[focus-visible=true]:outline-2 data-[focus-visible=true]:outline-focus data-[focus-visible=true]:outline-offset-2 text-tiny gap-2 rounded-full px-0 !gap-0 transition-transform-colors-opacity motion-reduce:transition-none text-default-foreground min-w-8 w-8 h-8 data-[hover=true]:opacity-hover bg-background/60 backdrop-blur-md backdrop-saturate-150 dark:bg-default-100/50"
        >
          {svg}
        </Button>
      ) : (
        <>{svg}</>
      )}
    </>
  );
};
